import { render, staticRenderFns } from "./Monitoring.vue?vue&type=template&id=7df68bbf&scoped=true&"
import script from "./Monitoring.vue?vue&type=script&lang=ts&"
export * from "./Monitoring.vue?vue&type=script&lang=ts&"
import style0 from "./Monitoring.vue?vue&type=style&index=0&id=7df68bbf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df68bbf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VDataTable,VIcon})
